import { Switch, useRouteMatch } from 'react-router-dom';
import { CampaignMembers } from 'assets/js/pages/campaign-settings/campaign-members/CampaignMembers';
import { CampaignMembersAddMemberDialog } from 'assets/js/pages/campaign-settings/campaign-members/CampaignMembersAddMemberDialog';
import { CampaignMembersEditMemberDrawer } from 'assets/js/pages/campaign-settings/campaign-members/CampaignMembersEditMemberDrawer';
import { DialogRoute } from 'components/dialog-route';
import { DrawerRoute } from 'components/drawer-route';
import { Route } from 'components/router/Route';

const CampaignMembersRouter = () => {
    const match = useRouteMatch();

    return (
        <>
            <DrawerRoute
                path={[`${match.path}/:memberId(\\d+)`]}
                component={CampaignMembersEditMemberDrawer}
            />
            <DialogRoute
                path={`${match.path}/new`}
                component={CampaignMembersAddMemberDialog}
                contentProps={{
                    className: 'md:min-w-[600px]',
                }}
            />
            <Switch>
                <Route path={match.path} component={CampaignMembers} />
            </Switch>
        </>
    );
};

export { CampaignMembersRouter };
